import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { listConveyor, unloadConveyorList } from '../../modules/conveyor/conveyorsSlice';
import StructureList from './StructureList';
// import { unloadConveyor } from '../../modules/conveyor/conveyorSlice';
import { useNavigate } from 'react-router-dom';
import { useCustomAlert } from '../../context/CustomAlertContext';
import { setOriginalConveyor } from '../../modules/conveyor/conveyorWriteSlice';

const StructureListContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const user = useSelector((state) => state.user.user);
    const project = useSelector((state) => state.project.project);
    const conveyors = useSelector((state) => state.conveyors.conveyors);
    const loading = useSelector((state) => state.loading);
    const error = useSelector((state) => state.conveyors.error);

    const language = useSelector((state) => state.language.language);
    const isEN = language === 'EN' ? true : false;
    const isJP = language === 'JP' ? true : false;

    const { showAlert } = useCustomAlert();

    /* 뒤로가기 등을 쭉 하다보면 리덕스에서 project가 지워지는 상황 발생. 이때는 전체 컨베이어가 뜨는 문제 발생 */
    if (!project) {
        navigate(`/projects`);
    }

    const onEditStructure = (conveyor) => {
        // Drive가 선정되었는지 점검 후 Structure Estimation 호출. '25.6.5일 수정함.
        const drives = conveyor.body.drives;
        const isDriveSelected = Array.isArray(drives) && drives.length > 0;
        if (!isDriveSelected) {
            const message = isEN
                ? 'Select drive(s) first'
                : isJP
                ? 'ドライブを最初に選択してください。'
                : '드라이브를 먼저 선정하세요';
            // alert(message);
            // return;

            showAlert(message);
            return;
        }

        /* 1) 컨베이어 리스트를 스토어에서 unloadConvyorList하고 
                   2) props로 받은 conveyor를 스토어의 writeConveyor에 쓴 후
                   3) StructureEstimatePage로 이동한다. */
        dispatch(unloadConveyorList());
        dispatch(setOriginalConveyor(conveyor));
        navigate('/write/structure');
    };

    useEffect(() => {
        const tag = searchParams.get('tag');
        const page = parseInt(searchParams.get('page'), 10) || 1;
        const username = user ? user.username : null;
        const projectId = project?._id;

        dispatch(
            listConveyor({
                projectId,
                username,
                tag,
                page,
            }),
        );

        // 여기서 다른 곳으로 갈 때(예를 들어 타워리스트 등으로) 컨베이어 리스트를 unload해줘야 함.
        return () => {
            dispatch(unloadConveyorList());
        };
    }, [dispatch, project?._id, searchParams, user]);

    const ownProject = (user && user._id) === (project && project.user._id);

    return (
        <StructureList
            conveyors={conveyors}
            loading={!loading}
            error={error}
            project={project}
            ownProject={ownProject}
            onEditStructure={onEditStructure}
        />
    );
};

export default StructureListContainer;
